import i18n, { init } from "i18next";
import { initReactI18next } from 'react-i18next';
import translationKRILL from './krill/translationKRILL.json';
import translationRU from './ru/translationRU.json';
import translationUZ from './uz/TranslationUZ.json';
import translationKK from './kk/TranslationKK.json';

const resources = {
    "ру": {
        translation: translationRU
    },
    "o'z": {
        translation: translationUZ
    },
    "ўз": {
        translation: translationKRILL
    },
    // "kk": {
    //     translation: translationKK
    // },


}

i18n
    .use(initReactI18next)
init({
    resources,
    lng: "uz",
    keySeparator: false,
    detection: {
        order: ['path', 'cookie', 'htmlTag', 'localStorage', 'subdomain'],
        caches: ['cookie']
    },

    interpolation: {
        escapeValue: false
    }
});

export default i18n;